import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import BatchSearchProgressModal from './BatchSearchProgressModal';
import {
  status as statusSelector,
  queryRunning as queryRunningSelector,
  queriesTotal as queriesTotalSelector,
  singleDatabase as singleDatabaseSelector,
  progressPercentage as progressPercentageSelector,
  currentDbName as currentDbNameSelector,
} from './BatchSearchProgressModalSelectors';

import BatchSearchProgressModalReducer from './BatchSearchProgressModalReducer';
import { batchSearchProgressModalReducerKey } from './BatchSearchProgressModalConstants';
import { cancelSearch, destroy, init } from './BatchSearchProgressModalActions';

const mapStateToProps = (state, ownProps) => ({
  status: statusSelector(state),
  queryRunning: queryRunningSelector(state),
  queriesTotal: queriesTotalSelector(state),
  singleDatabase: singleDatabaseSelector(state),
  progressPercentage: progressPercentageSelector(state),
  currentDbName: currentDbNameSelector(ownProps.priorityWatcher),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init(ownProps.batchFile)),
  destroy: () => dispatch(destroy()),
  cancelSearch: () => dispatch(cancelSearch(ownProps.searchId)),
});

export default compose(
  withReducer(batchSearchProgressModalReducerKey, BatchSearchProgressModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchSearchProgressModal);
